"use strict";

exports.__esModule = true;
exports.CHECK_STATE = exports.COLOR = exports.STATUS = exports.SIZE = exports.PAGINATION_ICON_NAMES = exports.STATUS_ICON_NAMES = void 0;
var STATUS_ICON_NAMES = {
  info: 'info',
  success: 'check-circle',
  error: 'close-circle',
  warning: 'remind'
};
exports.STATUS_ICON_NAMES = STATUS_ICON_NAMES;
var PAGINATION_ICON_NAMES = {
  more: 'more',
  prev: 'page-previous',
  next: 'page-next',
  first: 'page-top',
  last: 'page-end'
};
exports.PAGINATION_ICON_NAMES = PAGINATION_ICON_NAMES;
var SIZE = ['lg', 'md', 'sm', 'xs'];
exports.SIZE = SIZE;
var STATUS = ['success', 'warning', 'error', 'info'];
exports.STATUS = STATUS;
var COLOR = ['red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'violet'];
/**
 *  Check Tree Node State
 */

exports.COLOR = COLOR;
var CHECK_STATE = {
  UNCHECK: 0,
  // 未选择
  CHECK: 1,
  // 已选择
  INDETERMINATE: 2 // 半选

};
exports.CHECK_STATE = CHECK_STATE;